import { Box } from '@mui/material';
import { useEffect, useRef, useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

const RenderHTML = ({
  HTML,
  className = '',
  sx = {},
  onClick,
  id,
  innerRef,
  emptyHTML,
}) => {
  const { t } = useTranslation();
  const containerRef = useRef(null);

  const setRefs = useCallback(
    (node) => {
      containerRef.current = node;
      if (typeof innerRef === 'function') {
        innerRef(node);
      } else if (innerRef) {
        innerRef.current = node;
      }
    },
    [innerRef],
  );

  const html = useMemo(
    () =>
      HTML ||
      emptyHTML ||
      "<h1 style='text-align: center;'>" + t('EMPTY') + '</h1>',
    [HTML, emptyHTML, t],
  );

  useEffect(() => {
    var el = containerRef.current;
    if (!el) return;

    var scripts = el.querySelectorAll('script');
    scripts.forEach(function (script) {
      var type = script.getAttribute('type');
      if (
        type &&
        type !== 'text/javascript' &&
        type !== 'application/javascript'
      )
        return;
      if (script.src) return;
      var content = script.textContent;
      if (!content || !content.trim()) return;
      try {
        new Function(content)();
      } catch (e) {
        // ignore - script may contain template markup, not executable JS
      }
    });
  }, [html]);

  return (
    <Box
      ref={setRefs}
      id={id}
      onClick={onClick}
      className={className}
      sx={{
        ...sx,
      }}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
};

export default RenderHTML;
